import {
  FLOWCHART_DIRECTION_KEY,
  type FlowchartDirectionKey,
} from './flowchart-interactions';

enum FlowchartKeyboardKey {
  ArrowRight = 'ArrowRight',
  ArrowLeft = 'ArrowLeft',
  ArrowDown = 'ArrowDown',
  ArrowUp = 'ArrowUp',
  Enter = 'Enter',
  Space = ' ',
  Escape = 'Escape',
  Plus = '+',
  Equals = '=',
  Minus = '-',
  Underscore = '_',
}

export enum FlowchartKeyboardActionKind {
  None = 'none',
  Directional = 'directional',
  ZoomIn = 'zoomIn',
  ZoomOut = 'zoomOut',
  ClearFocus = 'clearFocus',
  RefocusNode = 'refocusNode',
}

interface FlowchartNoKeyboardAction {
  kind: FlowchartKeyboardActionKind.None;
}

interface FlowchartDirectionalKeyboardAction {
  kind: FlowchartKeyboardActionKind.Directional;
  direction: FlowchartDirectionKey;
}

export type FlowchartKeyboardCommandKind =
  | FlowchartKeyboardActionKind.ZoomIn
  | FlowchartKeyboardActionKind.ZoomOut
  | FlowchartKeyboardActionKind.ClearFocus
  | FlowchartKeyboardActionKind.RefocusNode;

interface FlowchartCommandKeyboardAction {
  kind: FlowchartKeyboardCommandKind;
}

export type FlowchartKeyboardAction =
  | FlowchartNoKeyboardAction
  | FlowchartDirectionalKeyboardAction
  | FlowchartCommandKeyboardAction;

export type FlowchartKeyboardCommandRunnerByKind = Record<FlowchartKeyboardCommandKind, () => void>;

const FLOWCHART_NO_KEYBOARD_ACTION: FlowchartNoKeyboardAction = {
  kind: FlowchartKeyboardActionKind.None,
};

const FLOWCHART_KEYBOARD_ACTION_BY_KEY: Partial<Record<string, FlowchartKeyboardAction>> = {
  [FlowchartKeyboardKey.Plus]: { kind: FlowchartKeyboardActionKind.ZoomIn },
  [FlowchartKeyboardKey.Equals]: { kind: FlowchartKeyboardActionKind.ZoomIn },
  [FlowchartKeyboardKey.Minus]: { kind: FlowchartKeyboardActionKind.ZoomOut },
  [FlowchartKeyboardKey.Underscore]: { kind: FlowchartKeyboardActionKind.ZoomOut },
  [FlowchartKeyboardKey.Escape]: { kind: FlowchartKeyboardActionKind.ClearFocus },
  [FlowchartKeyboardKey.Enter]: { kind: FlowchartKeyboardActionKind.RefocusNode },
  [FlowchartKeyboardKey.Space]: { kind: FlowchartKeyboardActionKind.RefocusNode },
  [FlowchartKeyboardKey.ArrowUp]: {
    kind: FlowchartKeyboardActionKind.Directional,
    direction: FLOWCHART_DIRECTION_KEY.Up,
  },
  [FlowchartKeyboardKey.ArrowDown]: {
    kind: FlowchartKeyboardActionKind.Directional,
    direction: FLOWCHART_DIRECTION_KEY.Down,
  },
  [FlowchartKeyboardKey.ArrowLeft]: {
    kind: FlowchartKeyboardActionKind.Directional,
    direction: FLOWCHART_DIRECTION_KEY.Left,
  },
  [FlowchartKeyboardKey.ArrowRight]: {
    kind: FlowchartKeyboardActionKind.Directional,
    direction: FLOWCHART_DIRECTION_KEY.Right,
  },
};

export function getFlowchartKeyboardAction(key: string): FlowchartKeyboardAction {
  return FLOWCHART_KEYBOARD_ACTION_BY_KEY[key] ?? FLOWCHART_NO_KEYBOARD_ACTION;
}
